'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import API from './API';
import LanguageUtil from '../util/LanguageUtil';
var URL = '/websitegrader/v2/form/submission';
var SUB_SOURCE = 'Website Grader 2015'; // Only supported subscriber languages are listed here (exluding English)

var supportedSubscriberlanguages = {
  de: 'German',
  es: 'Spanish',
  fr: 'French',
  ja: 'Japanese',
  pt: 'Portuguese'
};
var ENGLISH = 'English';
var hubspotutk;
window._hsq = window._hsq || [];

window._hsq.push(['addUserTokenListener', function (userToken) {
  hubspotutk = userToken;
}]);

var _default = /*#__PURE__*/function (_API) {
  _inherits(_default, _API);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "getSubscriberLanguage",
    value: function getSubscriberLanguage() {
      var userLanguage = LanguageUtil.getUserLanguage();
      return supportedSubscriberlanguages[userLanguage];
    }
  }, {
    key: "getSubscriberSource",
    value: function getSubscriberSource(subscriberLanguage) {
      if (!subscriberLanguage) {
        return SUB_SOURCE;
      } // E.g. Website Grader German 2015


      return "Website Grader " + subscriberLanguage + " 2015";
    }
    /**
     * Save the contact in the HubSpot portal/form provided.
     */

  }, {
    key: "save",
    value: function save(contactEmail, websiteGrade) {
      var subscriberLanguage = this.getSubscriberLanguage();
      var subscriberSource = this.getSubscriberSource(subscriberLanguage);

      var getDateAtMidnight = function getDateAtMidnight() {
        return new Date().setUTCHours(0, 0, 0, 0);
      };

      var data = {
        formData: {
          content_language: subscriberLanguage || ENGLISH,
          email: contactEmail,
          lifecyclestage: 'subscriber',
          subscribersource_2: subscriberSource,
          wg_recent_website_url: websiteGrade.get('domain'),
          wg_recent_report_url: location.href,
          wg_overall_score: websiteGrade.get('overallGrade'),
          wg_performance_score: websiteGrade.getIn(['performanceAudit', 'grade']),
          wg_mobile_responsiveness_score: websiteGrade.getIn(['mobileAudit', 'grade']),
          wg_seo_score: websiteGrade.getIn(['seoAudit', 'grade']),
          wg_security_score: websiteGrade.getIn(['securityAudit', 'grade']),
          wg_submission_date: getDateAtMidnight()
        },
        hutk: hubspotutk,
        pageUri: window.location.href
      };
      return this.makePostRequest(URL, {
        data: data
      });
    }
  }]);

  return _default;
}(API);

export { _default as default };